import { useSuspenseQuery } from '@tanstack/react-query';

import { getBookValidationOptions, useValidateBook } from '@/module/Author/Book/Validation/model/BookValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  bookId: Id;
  variant?: ValidationVariant;
}

export function BookValidationAction({ bookId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getBookValidationOptions(bookId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateBook(bookId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
